/**
 * Mode-aware navigation hook
 * Ensures navigation always maintains the current mode context
 */

import { useNavigate } from 'react-router';
import { getAppMode, getUrlId, isValidTemplate } from '../utils/appConfig';

export const useAppNavigate = () => {
  const navigate = useNavigate();
  const mode = getAppMode();
  const urlId = getUrlId();

  return (to: string) => {
    // Clean the path - remove leading slash if present
    const cleanPath = to.startsWith('/') ? to.slice(1) : to;
    
    if (mode === "edit" && urlId) {
      // Edit mode: /restaurant-id/preview/edit/path
      const editPath = cleanPath === '' ? '' : `/${cleanPath}`;
      const targetUrl = `/${urlId}/preview/edit${editPath}`;
      navigate(targetUrl);
    } else if (mode === "preview" && urlId && isValidTemplate(urlId)) {
      // Preview mode: /template-name/preview/path (e.g., /pizza/preview/menu)
      const previewPath = cleanPath === '' ? '' : `/${cleanPath}`;
      const targetUrl = `/${urlId}/preview${previewPath}`;
      navigate(targetUrl);
    } else if (mode === "restaurant" && urlId) {
      // Restaurant mode: /restaurant-id/path
      const restaurantPath = cleanPath === '' ? '' : `/${cleanPath}`;
      const targetUrl = `/${urlId}${restaurantPath}`;
      navigate(targetUrl);
    } else {
      // Normal mode: /path
      const normalPath = cleanPath === '' ? '/' : `/${cleanPath}`;
      navigate(normalPath);
    }
  };
};

export default useAppNavigate;
